const RELOAD_KEY = 'aegis:chunk-recovery-attempted'
const CHUNK_ERROR_RE = /Failed to fetch dynamically imported module|error loading dynamically imported module|Importing a module script failed|Unable to preload CSS|NS_ERROR_CORRUPTED_CONTENT|not allowed .* MIME type|MIME type .* not allowed|expected a JavaScript(?:-or-Wasm)? module script/i

export function isChunkError(error: unknown): boolean {
  const message = error instanceof Error ? error.message : String(error ?? '')
  return CHUNK_ERROR_RE.test(message)
}

// One automatic attempt per tab, shared by Vite and the router. A time-based
// cooldown can still loop forever on slow networks. Manual retry stays available.
// If storage is blocked, do not reload: the guard would not survive navigation.
export function reloadForChunkError(): boolean {
  try {
    if (sessionStorage.getItem(RELOAD_KEY)) return false
    sessionStorage.setItem(RELOAD_KEY, '1')
  } catch {
    return false
  }
  window.location.reload()
  return true
}
